export default {
  provinceOptions: (state) => {
    const provinceOptions = [];
    state.provinces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },

  cityOptions: (state) => {
    const cityOptions = [];
    state.cities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      cityOptions.push(pushItem);
    }
    return cityOptions;
  },

  internalUnitOptions: (state) => {
    const internalUnitOptions = [];
    state.internalUnits.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      internalUnitOptions.push(pushItem);
    }
    return internalUnitOptions;
  },

  roleOptions: (state) => {
    const roleOptions = [];
    state.roles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      roleOptions.push(pushItem);
    }
    return roleOptions;
  },

  tariffTypeOptions: (state) => {
    const tariffTypeOptions = [];
    state.tariffTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      tariffTypeOptions.push(pushItem);
    }
    return tariffTypeOptions;
  },

  vehicleOptions: (state) => {
    const vehicleOptions = [];
    state.vehicles.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        typeId: item.vehicleType,
      };
      vehicleOptions.push(pushItem);
    }
    return vehicleOptions;
  },

  smsTemplates: (state) => {
    return state.smsTemplates;
  },

  settingDropdown: (state) => {
    return state.settingDropdown;
  },

  companyOptions: (state) => {
    const companyOptions = [];
    state.companies.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      companyOptions.push(pushItem);
    }
    return companyOptions;
  },

  fiscalYearOptions: (state) => {
    const fiscalYearOptions = [];
    state.fiscalYears.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.title,
        text: item.title,
      };
      fiscalYearOptions.push(pushItem);
    }
    return fiscalYearOptions;
  },

  accountInfoOptions: (state) => {
    const accountInfoOptions = [];
    state.accountInfos.forEach(func);
    function func(item) {
      const pushItem = {
        value: String(item.id),
        text: item.title,
      };
      accountInfoOptions.push(pushItem);
    }
    return accountInfoOptions;
  },

  subscriberOptions: (state) => {
    const subscriberOptions = [];
    state.subscribers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.brand + " | " + item.contractNumber,
      };
      subscriberOptions.push(pushItem);
    }
    return subscriberOptions;
  },

  activityGroupOptions: (state) => {
    const activityGroupOptions = [];
    state.activityGroups.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      activityGroupOptions.push(pushItem);
    }
    return activityGroupOptions;
  },

  waterBillPeriodOptions: (state) => {
    const waterBillPeriodOptions = [];
    state.waterBillPeriods.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      waterBillPeriodOptions.push(pushItem);
    }
    return waterBillPeriodOptions;
  },

  meterReadingOptions: (state) => {
    const meterReadingOptions = [];
    state.meterReadings.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text:
          item.waterBillPeriodTitle +
          " | " +
          item.brand +
          " | " +
          item.dateLocal +
          " | " +
          item.number,
      };
      meterReadingOptions.push(pushItem);
    }
    return meterReadingOptions;
  },

  automationTypeOptions: (state) => {
    const automationTypeOptions = [];
    state.automationTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      automationTypeOptions.push(pushItem);
    }
    return automationTypeOptions;
  },

  serviceTypeOptions: (state) => {
    const serviceTypeOptions = [];
    state.serviceTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      serviceTypeOptions.push(pushItem);
    }
    return serviceTypeOptions;
  },

  billboardOptions: (state) => {
    const billboardOptions = [];
    state.billboards.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code + " | " + item.type,
      };
      billboardOptions.push(pushItem);
    }
    return billboardOptions;
  },

  billboardRequestStatusOptions: (state) => {
    const billboardRequestStatusOptions = [];
    state.billboardRequestStatuses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      billboardRequestStatusOptions.push(pushItem);
    }
    return billboardRequestStatusOptions;
  },

  vehicleTypeOptions: (state) => {
    const vehicleTypeOptions = [];
    state.vehicleTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      vehicleTypeOptions.push(pushItem);
    }
    return vehicleTypeOptions;
  },

  automationOptions: (state) => {
    const automationOptions = [];
    state.automations.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.code + " | " + item.dateLocal + " | " + item.brand,
      };
      automationOptions.push(pushItem);
    }
    return automationOptions;
  },

  personTypeOptions: (state) => {
    const personTypeOptions = [];
    state.personTypes.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      personTypeOptions.push(pushItem);
    }
    return personTypeOptions;
  },

  tariffOptions: (state) => {
    const tariffOptions = [];
    state.tariffs.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      tariffOptions.push(pushItem);
    }
    return tariffOptions;
  },

  accountOptions: (state) => {
    const accountOptions = [];
    state.accounts.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      accountOptions.push(pushItem);
    }
    return accountOptions;
  },

  projectOptions: (state) => {
    const projectOptions = [];
    state.projects.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.code,
        text: item.title,
      };
      projectOptions.push(pushItem);
    }
    return projectOptions;
  },

  paymentProcessOptions: (state) => {
    const paymentProcessOptions = [];
    state.paymentProcesses.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      paymentProcessOptions.push(pushItem);
    }
    return paymentProcessOptions;
  },

  setting: (state) => {
    return state.setting;
  },

  // Static Getters ---------------------------------------------------------------
  genderOptions() {
    return [
      { value: 1, text: "مرد" },
      { value: 2, text: "زن" },
    ];
  },

  paymentOptions() {
    return [
      { value: "PayWaterBill", text: "پرداخت قبض آب" },
      { value: "PayChargeBill", text: "پرداخت قبض شارژ" },
      { value: "PayBillboardRequest", text: "پرداخت درخواست  بیلبورد" },
      { value: "PayServiceRequest", text: "پرداخت درخواست  خدمات" },
    ];
  },

  payTypeOptions() {
    return [
      { value: "BankPortal", text: "درگاه بانکی" },
      { value: "Cash", text: "نقدی" },
    ];
  },
};
